import { render, staticRenderFns } from "./ImageOverlay.vue?vue&type=template&id=25c2c83e"
import script from "./ImageOverlay.vue?vue&type=script&lang=js"
export * from "./ImageOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports